import { AuthContext } from 'context/auth-context';
import { useContext } from 'react';

function useCardSettings() {
    const { publicSettings } = useContext(AuthContext);
    const { CARD_CREATION_ENABLED = { value: '1' } } = publicSettings;

    return {
        isCreationEnabled: CARD_CREATION_ENABLED?.value === '1'
    };
}

export default useCardSettings;
